<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="uslugeTable"
    [chipItems]="chipItems"
    [isTableLoading]="isLoading"
  >
  </kodit-table>
</kodit-page>
